export default {
  props: ['id'],
  computed: {
    user() {
      return this.$store.state.user;
    },
    publication() {
      return this.$store.state.news.publication;
    },
  },
  methods: {
    setPublicationReaded() {
      const payload = {
        profile_id: this.user.profile_id,
        news_id: +this.id,
      };
      return this.$store.dispatch('news/SetPublicationReaded', payload);
    },
  },
  async created() {
    if (!this.user || !this.id) return;
    // API actions report their own errors; stop the chain after a failed request.
    if (!this.$store.state.news.news.length) {
      const news = await this.$store.dispatch('news/GetNews', this.user.profile_id).catch(() => null);
      if (!news) return;
    }
    await this.$store.dispatch('news/SetPublication', +this.id);
    if (this.publication) await this.setPublicationReaded().catch(() => {});
  },
};
